import { WellScreenTypeBase } from './base/well-screen-type-base';

export class WellScreenType extends WellScreenTypeBase { }